import { gql } from '@apollo/client';

export interface StaffDeleteCarpoolTripMutation {
  staffDeleteCarpoolTrip: {
    id: string;
  };
}

export interface StaffDeleteCarpoolTripMutationVariables {
  tripId: string;
}

export const STAFF_DELETE_CARPOOL_TRIP = gql`
  mutation StaffDeleteCarpoolTrip($tripId: ID!) {
    staffDeleteCarpoolTrip(tripId: $tripId) {
      id
    }
  }
`;
